export const stripParenthesesContent = (text: string) => {
	return text.replace(/\s*\([^)]*\)/g, '')
}
